import type { SummaryPage } from "./sessionViewRoute.ts";

const JOIN_CODE_LENGTH = 6;

export function normalizeJoinCode(value: string | null | undefined): string {
  return (value ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, JOIN_CODE_LENGTH);
}

export function buildJoinPath(joinCode: string): string {
  return `/join/${normalizeJoinCode(joinCode)}`;
}

export function buildAdminPath(joinCode: string | null | undefined): string {
  const code = normalizeJoinCode(joinCode);
  return code ? `/admin/session/${code}` : "/admin";
}

export function buildAdminSummaryPath(joinCode: string, page: SummaryPage): string {
  return `${buildAdminPath(joinCode)}/summaries/${page}`;
}

export function buildJoinSummaryPath(joinCode: string, page: SummaryPage): string {
  return `${buildJoinPath(joinCode)}/summaries/${page}`;
}

export function buildModeratorPath(joinCode: string | null | undefined): string {
  const code = normalizeJoinCode(joinCode);
  return code ? `/moderator/session/${code}` : "/moderator";
}

export function buildProjectorPath(joinCode: string | null | undefined): string {
  const code = normalizeJoinCode(joinCode);
  return code ? `/projector/session/${code}` : "/projector";
}

export function buildJoinUrl(joinCode: string): string {
  const path = buildJoinPath(joinCode);
  return typeof window === "undefined" ? path : new URL(path, window.location.origin).toString();
}
